import { localStorage } from "../pages/customizer/__constant";
import $ from "jquery";
import { LocalStorage } from "storage-manager-js";

const ajaxBuyProducts = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      button: ".js-buy-products",
    };
    $(document).on("click", el.button, function (e) {
      e.preventDefault();
      const isLoggedIn = $(this).data("is_logged_in");
      const thisEl = $(this);
      if (!isLoggedIn) {
        const form = document.createElement("form");
        form.method = "POST";
        form.action = thisEl.data("action"); // Replace with the actual URL

        const type = document.createElement("input");
        type.type = "hidden";
        type.name = "type";
        type.value = thisEl.data("form_action");
        form.appendChild(type);

        const redirect_to = document.createElement("input");
        redirect_to.type = "hidden";
        redirect_to.name = "redirect_to";
        redirect_to.value = thisEl.data("redirect_to");
        form.appendChild(redirect_to);

        const product_ids = document.createElement("input");
        product_ids.type = "hidden";
        product_ids.name = "product_ids";
        product_ids.value = thisEl.find("input").val();
        form.appendChild(product_ids);

        document.body.appendChild(form);
        form.submit();
      } else {
        $("body").addClass("mi-loading");
        $.ajax({
          type: "POST",
          dataType: "json",
          url: thisEl.data("action"),
          data: {
            action: thisEl.data("form_action"),
            nonce: thisEl.data("nonce"),
            product_ids: thisEl.find("input").val(),
          },
          success: function (response) {
            $("body").removeClass("mi-loading");
            const popupData = JSON.parse($(".js-button-data__input").val());
            const popupDataForCart = {
              ...popupData,
              slug: "cart-request",
            };
            LocalStorage.set(localStorage.cartOfferte, popupDataForCart);
            if (response.success) {
              window.location.href = thisEl.data("redirect_to");
            }
          },
          error: (err) => {
            $("body").removeClass("mi-loading");
            console.error(err);
          },
        });
      }
    });
  };

  init();
};

try {
  ajaxBuyProducts();
} catch (error) {
  console.error("ajaxBuyProducts", error);
}
